import { render, staticRenderFns } from "./NoIncomeNotification.vue?vue&type=template&id=5cac1ee2&scoped=true"
import script from "./NoIncomeNotification.vue?vue&type=script&lang=js"
export * from "./NoIncomeNotification.vue?vue&type=script&lang=js"
import style0 from "./NoIncomeNotification.vue?vue&type=style&index=0&id=5cac1ee2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cac1ee2",
  null
  
)

export default component.exports